<template>
  <div id="app">
    <transition enterActiveClass="animated fadeIn" leaveActiveClass="animated fadeOut" mode="out-in">
      <div v-if="loading" class="shadow">
        <fade-loader :loading="loading" :color="'#00acff'" :height="'15px'" :width="'6px'"></fade-loader>
      </div>
    </transition>
    <div class="row">
      <div class="container">
        <router-view/>
        <img class="mx-auto d-block Logo mt-3" src="./assets/vect/logo.svg">
      </div>
    </div>
  </div>
</template>

<script>
import FadeLoader from 'vue-spinner/src/FadeLoader';
import { mapState } from 'vuex';

export default {
  name: 'app',
  data() {
    return {
    };
  },
  components: {
    FadeLoader,
  },
  computed: {
    ...mapState(['loading']),
  },
};
</script>

<style>
body{
  font-family: Roboto;
  font-weight: 400;
  background-color: black;
}
#app {
  background-color: black;
  height: 100vh;
}
.Heading{
  color: white;
}
.shadow{
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,1);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 101;
}
</style>



// WEBPACK FOOTER //
// src/App.vue